import { z, ZodTypeAny } from 'zod';

const options = [
    { value: 'A', label: 'A' },
    { value: 'B', label: 'B' },
    { value: 'C', label: 'C' },
    { value: 'D', label: 'D' },
    { value: 'K', label: 'K' },
    { value: 'Z', label: 'Z' },
    { value: 'custom', label: 'Custom' },
];

const TripCurves: {
    validator: ZodTypeAny;
    options: {
        value: string;
        label: string;
    }[];
} = {
    // @ts-ignore
    validator: z.array(z.enum(options.map((option) => option.value))),
    options,
};

export { TripCurves };
